<template lang="html">
    <div class="z-properties-log can-scroll" v-loader-overlay="progress">
        <div class="z-properties-log__list" v-if="logs && Object.keys(logs).length">
            <div class="z-properties-log__item" v-for="item in logs" v-bind:key="`z-properties-log-item-${item.id}`">
                <div class="z-properties-log__item-body" v-if="item.description">
                    <span v-html="item.description"></span>
                </div>
                <div class="z-properties-log__item-footer" v-if="item.created_at">
                    <span>
                        {{
                            moment.tz(item.created_at, $root.defaultTimezone).fromNow() + 
                                ' (' + moment(item.created_at).tz($root.userTimezone).format('HH:mm:ss DD.MM.YYYY') + ')'
                        }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  import ZButton from "@/components/ZButton"
  export default {
    name: 'ZModulePropertiesLogs',
    components: { ZButton },
    props: {
        module: {
            type: String,
            default: ''
        },
        properties: {
            type: Array,
            default: () => [],
            required: true
        }        
    },
    data() {
        return {
            feed: [],
        }
    },
    created() {
        this.getLogs();
    },
    watch: {},
    computed: {
        /**
         * Флаг загрузки текущего компонента
         */
        progress() {
            return this.progressObj[this.progressKey];
        },        
        progressKey() {
          return `load-comments-${this.$props.module}`
        },
        progressCommentsAndLogs() {
            return this.progressObj[this.progressKey];
        },
        progressObj() {
            return this.$store.state.progressObj;
        },
        logs() {
            return this.$store.state.module.propertiesValuesLog
        }
    },
    methods: {
        getLogs() {
            this.$store.commit('showProgressBar', this.progressKey);
            this.$store.dispatch('module/getModulePropertiesValuesLog', {
                code:       this.$props.module,
                properties: this.$props.properties
            }).finally(() => this.$store.commit('hideProgressBar', this.progressKey));
        }
    }
  }
</script>
<style lang="sass">
.z-properties-log
    max-height: 100%
    overflow: auto
    .z-properties-log__item
        font-size: 12px
        margin-left: 30px
        position: relative
        font-size: 12px
        line-height: 20px
        margin-bottom: 15px            
        ul
            list-style: none
            padding: 0 !important
            li::before
                content: '\2022'
                color: #2196F3
                display: inline-block
                padding-right: 6px
        &:last-child
            &::before
                display: none
        &::before
            content: ''
            height: 100%
            width: 1px
            background-color: #E5E5E5
            position: absolute
            top: 20px
            left: -20px
        &::after
            content: 'settings'
            position: absolute
            top: 0
            left: -30px
            width: 20px
            height: 20px
            border-radius: 50%
            color: #fff
            font-family: 'Material Icons'
            display: flex
            align-items: center
            justify-content: center
            font-size: 12px
            background-color: #2196F3
        .z-properties-log__item-body
            margin-bottom: 4px
        .z-properties-log__item-footer
            font-size: 10px
            line-height: 12px
            color: #888
</style>



// WEBPACK FOOTER //
// ZModulePropertiesLogs.vue?4b754d92